import React, { useState, useEffect } from "react";
import { FiUser } from "react-icons/fi";
import { LuCrown } from "react-icons/lu";
import SubscriptionTab from "../../components/admin/profile-subscription/SubscriptionTab";
import ProfileTab from "../../components/admin/profile-subscription/ProfileTab";

const ProfileAndSubscription = () => {
  const [activeTab, setActiveTab] = useState("profile");
  

  return (
    <div className="min-h-screen bg-gray-50 py-3 sm:py-4 md:py-6 pl-3 sm:pl-4 md:pl-6 pr-2 sm:pr-3 md:pr-4">
      {/* Header */}
      <div className="mb-6 font-poppins">
        <h1 className="text-2xl font-semibold text-text-primary mb-1">
          Profile & Subscription
        </h1>
        <p className="text-text-muted text-sm">
          Manage your account and subscription
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="flex flex-wrap gap-3 sm:gap-4 mb-4 sm:mb-6 border-b border-gray-200">
        <button
          onClick={() => setActiveTab("profile")}
          className={`flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2 sm:py-3 rounded-t-md font-medium text-sm sm:text-base transition-all duration-200 ${
            activeTab === "profile"
              ? "text-primary border-b-2 border-primary bg-gray-100"
              : "text-gray-600 hover:text-primary hover:bg-gray-200"
          }`}
        >
          <FiUser className="w-4 h-4 sm:w-5 sm:h-5" />
          <span>Profile Details</span>
        </button>

        <button
          onClick={() => setActiveTab("subscription")}
          className={`flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2 sm:py-3 rounded-t-md font-medium text-sm sm:text-base transition-all duration-200 ${
            activeTab === "subscription"
              ? "text-primary border-b-2 border-primary bg-gray-100"
              : "text-gray-600 hover:text-primary hover:bg-gray-200"
          }`}
        >
          <LuCrown className="w-4 h-4 sm:w-5 sm:h-5" />
          <span>Subscription</span>
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === "profile" && (
        <ProfileTab />
      )}

      {activeTab === "subscription" && <SubscriptionTab />}
    </div>
  );
};

export default ProfileAndSubscription;
